import { useState } from "react";
import { Link } from "react-router-dom";
//import MetedStaticData from "./data_sets/MetedStaticData";
import Footer from "./Footer";
import { connect } from "react-redux";
//import { useParams } from "react-router-dom";
import {
  ArrowTopRightOnSquareIcon,
  /*XMarkIcon,*/
} from "@heroicons/react/24/outline";
import { FormattedMessage } from "react-intl";
import { useIntl } from "react-intl";


const RegisterContainer = (props) => {
  //const { dispatch, viewer } = props;
  //const { locale } = viewer.language;
  //const params = useParams();
  const intl = useIntl();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  const emailCategory = (value) => {
    const trimmed = value.trim().toLowerCase();
    const parts = trimmed.split("@");
    if (parts.length !== 2) return "general";
    const domain = parts[1];

    if (domain === "noaa.gov" || domain.endsWith(".noaa.gov")) {
      return "noaa";
    }

    if (
      domain === "ec.gc.ca" ||
      domain.endsWith(".ec.gc.ca") ||
      domain.endsWith(".canada.ca")
    ) {
      return "eccc";
    }

    return "general";
  };

  const registrationUrl = (category, email) => {
    //const encodedEmail = encodeURIComponent(email);
    switch (category) {
      case "noaa":
        return `https://learn.meted.ucar.edu?KeyName=NOAA_KEY`;
      case "eccc":
        return `https://learn.meted.ucar.edu?KeyName=Environment%20and%20Climate%20Change%20Canada`;
      default:
        return `https://learn.meted.ucar.edu?KeyName=Public_KEY`;
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const trimmedEmail = email.trim();
    const validEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!validEmail.test(trimmedEmail)) {
      setError("Please enter a valid email address.");
      return;
    }

    setError("");
    const target = registrationUrl(emailCategory(trimmedEmail), trimmedEmail);
    window.location.href = target;
  };

  return (
    <section id="meted-landing">
      {/* EMAIL CHECK FORM */}
      <section className="py-12 px-4 sm:px-6 lg:px-8">
        <div className="mb-8 max-w-7xl mx-auto">
          <h2 className="text-3xl font-bold tracking-tight text-[#1A658F]">
            <FormattedMessage
              id="register.for_meted"
              defaultMessage="Register for MetEd"
            />
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            <FormattedMessage
              id="register.for_meted_blurb"
              defaultMessage="Enter your email address to begin the registration process and access MetEd's educational resources. If you already have an account, you can log in to access your courses and track your progress."
            />
          </p>
          <form onSubmit={handleSubmit} className="mt-6 text-center">
            <input
              type="email"
              placeholder={intl.formatMessage({ id: "register.email_field", defaultMessage: "Enter your email" })}
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              className="w-full max-w-md px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1A658F] focus:border-[#1A658F]"
              aria-label="Email address"
            />
            <div className="mt-4">
              <button
                type="submit"
                className="px-6 py-3 bg-[#1A658F] text-white font-medium rounded-md shadow-sm hover:bg-cyan-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#1A658F]"
              >
                <FormattedMessage
                  id="register.button"
                  defaultMessage="Begin Registration"
                /> &rarr;
              </button>
            </div>
            {error && (
              <p className="mt-3 text-sm text-red-600">{error}</p>
            )}
          </form>
          <div className="mt-4 text-center"></div>
        </div>
      </section>

  

      {/* QUICK LINKS */}
      <section className="py-12 px-4 sm:px-6 lg:px-8 border-t border-gray-200">
        <div className="mb-8 max-w-7xl mx-auto">
          <h2 className="text-3xl font-bold tracking-tight text-[#1A658F]">
            <FormattedMessage
              id="meted.quick_links"
              defaultMessage="Quick Links"
            />
          </h2>

          <div className="my-4 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            <div className="border rounded-lg bg-[#1A658F] text-white text-center py-2 shadow-md hover:-translate-y-1 transition-all duration-100">
              <Link to="/help" className="flex flex-col items-center">
                <div className="p-2">
                  <h1 className="text-lg font-bold">
                    <FormattedMessage
                      id="meted.help_center"
                      defaultMessage="Support & FAQs"
                    />
                  </h1>
                  <p className="text-sm p-2">
                    <FormattedMessage
                      id="meted.help_center_description"
                      defaultMessage="Technical Support and Frequently Asked Questions"
                    />
                  </p>
                  <div className="flex justify-center">
                    <ArrowTopRightOnSquareIcon className="h-8 w-8 text-white" />
                  </div>
                </div>
              </Link>
            </div>

            <div className="border rounded-lg bg-[#1a658f] text-white text-center py-2 shadow-md hover:-translate-y-1 transition-all duration-100">
              <Link
                to="https://www.comet.ucar.edu/"
                className="flex flex-col items-center"
              >
                <div className="p-2">
                  <h1 className="text-lg font-bold">
                    <FormattedMessage
                      id="meted.comet_program"
                      defaultMessage="The COMET Program"
                    />
                  </h1>
                  <p className="text-sm p-2">
                    <FormattedMessage
                      id="meted.comet_program_description"
                      defaultMessage="Learn more about the COMET Program and its educational initiatives"
                    />
                  </p>
                  <div className="flex justify-center">
                    <ArrowTopRightOnSquareIcon className="h-8 w-8 text-white" />
                  </div>
                </div>
              </Link>
            </div>

            <div className="border rounded-lg bg-[#1a658f] text-white text-center py-2 shadow-md hover:-translate-y-1 transition-all duration-100">
              <Link to="/transcripts" className="flex flex-col items-center">
                <div className="p-2">
                  <h1 className="text-lg font-bold">
                    <FormattedMessage
                      id="meted.my_meted_records"
                      defaultMessage="My MetEd Records"
                    />
                  </h1>
                  <p className="text-sm p-2">
                    <FormattedMessage
                      id="meted.my_meted_records_description"
                      defaultMessage="Download your legacy transcripts, certificates, and queue here"
                    />
                  </p>
                  <div className="flex justify-center">
                    <ArrowTopRightOnSquareIcon className="h-8 w-8 text-white" />
                  </div>
                </div>
              </Link>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </section>
  );
};

function mapStateToProps({ user, viewer, dispatch }) {
  return { user, viewer, dispatch };
}

export default connect(mapStateToProps)(RegisterContainer);
